import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useMedicineServiceResponsible } from '../_hooks/useMedicineServiceResponsible';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function ResponsibleMedicineServiceFormItem({ fieldName = '' }: Readonly<FormItemProps>): JSX.Element {
	const { isLoading, data, addItem, handleSearch, handleInputChange } = useMedicineServiceResponsible({ fieldName });

	return (
		<FormItem
			required
			name={fieldName}
			label="Responsible of the Occupational Medicine Service"
			requiredMessage="Please select a responsible of the occupational medicine service"
		>
			<Select.Multiple
				isAdd
				isSingle
				options={data}
				textButton="Add"
				addItem={addItem}
				loading={isLoading}
				onSearch={handleSearch}
				onInputChange={handleInputChange}
				placeholder="Select a responsible"
				placeholderInput="Please enter a responsible"
			/>
		</FormItem>
	);
}
